module.exports = __webpack_public_path__ + "img/huawei-p9-lite.46586e02.jpg";